import { pageName } from "constants/pageNames";
import { FormModal } from "./ModalForForm";
import { Button, Paper, Typography } from "@mui/material";
import { PageTitle } from "components/PageMeta/PageTitle";
import {
  DONE_STATUS_VALIDATION_FIELD_TYPES,
  IO_FOR_PRODUCT_EXECUTION_TIMELINE,
} from "constants/taskConstants";
import { TextFieldWrapper } from "components/Wrappers/FormComponentsWrappers/TextFieldWrapper";

export const ModalForDoneStatusProductTask = ({
  openDoneStatusModal,
  setOpenDoneStatusModal,
  timelineItem,
  handleDoneStatusOutputSubmit,
  doneOutput,
  setDoneOutput,
}) => {
  const handleChange = (e, index) => {
    let temp = [...doneOutput];
    temp[index] = e.target.value;
    setDoneOutput([...temp]);
  };
  return (
    <FormModal
      open={openDoneStatusModal}
      onClose={() => setOpenDoneStatusModal(false)}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
      closeAfterTransition
    >
      <Paper className="formModal-class">
        <PageTitle pageName={pageName.task.doneStatusOutput} />
        <form onSubmit={handleDoneStatusOutputSubmit}>
          <Typography>{timelineItem}</Typography>
          {DONE_STATUS_VALIDATION_FIELD_TYPES.subjective.includes(
            timelineItem
          ) &&
            IO_FOR_PRODUCT_EXECUTION_TIMELINE[timelineItem]
              .isRequiredInDoneStatus &&
            IO_FOR_PRODUCT_EXECUTION_TIMELINE[timelineItem].outputItems.map(
              (item, index) => (
                <TextFieldWrapper
                  key={index}
                  label={item}
                  variant="outlined"
                  value={doneOutput?.[index] || ""}
                  fullWidth
                  required
                  onChange={(e) => handleChange(e, index)}
                />
              )
            )}
          <Button variant="contained" type="submit" fullWidth>
            Submit
          </Button>
        </form>
      </Paper>
    </FormModal>
  );
};
